module.exports = __webpack_public_path__ + "static/img/sabong.5ae3bc97.png";